
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
} from "recharts";

const SignalChartBox = ({ data, onClose }) => {



  const displayedData =  data;

  return (
    <div
      style={{
        position: "absolute",
        top: "60px",
        left: "60px",
        width: "90%",
        maxWidth: "1000px",
        height: "470px",
        background: "white",
        zIndex: 1000,
        padding: "10px",
        borderRadius: "10px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
      }}
    >
      {/* ❌ Close and 🔄 Reset buttons */}
      <div style={{  justifyContent: "space-between", marginBottom: "5px" , textAlign: 'right' }}>
        
   

        <button
          onClick={onClose}
          style={{
            border: "none",
            background: "transparent",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          ❌
        </button>
      </div>

      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={displayedData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="time" angle={-45} textAnchor="end" height={60} />
          <YAxis domain={[0, 100]} />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="signal" stroke="#008080" dot={false} />
        
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SignalChartBox;
